<template>
  <div>
    <h3 class="color-darkblue">{{ labor_spelling }}</h3>
    <div class="table-responsive-sm mt-4">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" class="text-right">SRT</th>
            <th scope="col" class="text-right">SRT Hours</th>
            <th scope="col" class="text-right">Claimed Hours</th>
            <th scope="col" class="text-right">Processed Hours</th>
            <th scope="col" class="text-right">{{ labor_spelling }} Rate</th>
            <th scope="col" class="text-right">{{ labor_spelling }} Claimed Amount</th>
            <th scope="col" class="text-right">{{ labor_spelling }} Processed Amount</th>
            <th scope="col" class="text-right">Attachment</th>
            <th scope="col"> Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>
              <v-select class="close-remove" v-model="row.srt" :disabled="disableAll" id="srt" name="srt"
                @search="onSearchSrt" @input="populateSrtFields(index)" placeholder="Search SRT" label="text"
                :options="srtArr">
              </v-select>
              <div class="field-error">{{ row.srt_error_msg }}</div>
            </td>
            <td>
              <input type="number" placeholder="SRT Hours" v-model="row.srt_hours" :id="'srt_hours' + index"
                style="width:99% !important" :name="'srt_hours' + index" class="vgt-input text-right" :disabled="true">
            </td>
            <td>
              <input type="number" placeholder="Claimed Hours" v-model="row.claimed_hours" style="width:99% !important"
                :id="'claimed' + index" :name="'claimed' + index" class="vgt-input text-right" :disabled="disableAll"
                v-on:keyup="calculateLaborClaimedAmount(index)">
              <div class="field-error">{{ row.claimed_hours_error_msg }}</div>
            </td>
            <td>
              <input type="text" disabled placeholder="Processed" v-model="row.processed_hours" id="processed"
                name="processed" style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" disabled :placeholder="labor_spelling + ' Rate'" v-model="row.labor_rate" id="labor_rate_processed"
                name="labor_rate_processed" style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" disabled :placeholder="labor_spelling + ' Claimed Amount'" v-model="row.labor_claimed_amount"
                id="labor_claimed_amount" name="labor_claimed_amount" style="width:99% !important"
                class="vgt-input text-right" v-on:keyup="calculateLaborClaimedAmount(index)">
            </td>
            <td>
              <input type="text" disabled :placeholder="labor_spelling + ' Processed'" v-model="row.labor_processed_amount"
                id="labor_processed" name="labor_processed" style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <template v-if="row.attachmentPath == null">
                <input type="file" id="Total" name="partAttachment" @change="event => laborAttachmentUpload(index, event)"
                  class="vgt-input text-right" style="width:99% !important" ref="partAttachment">
                <div class="field-error">{{ row.attachmentError }}</div>
                <button class="btn btn-primary" id="uploadButton" style="margin: 4px;"
                  v-on:click.prevent="uploadAttachment('laborAttachment', index)">
                  <i class="fp-upload"> </i> Upload
                </button>
              </template>
              <template v-else>
                <i v-if="row.attachmentPath.extension == 'pdf'" class="fp-pdf-icon"></i>
                <i v-if="row.attachmentPath.extension == 'doc' || row.attachmentPath.extension == 'docs'"
                  class="fp-text-document"></i>
                <i v-if="row.attachmentPath.extension == 'jpg' || row.attachmentPath.extension == 'png' || row.attachmentPath.extension == 'jpeg'"
                  class="fp-image"></i>
                <a title='View File' href="javascript:void(0)"
                  v-on:click="openDocument(row.attachmentPath.url, row.attachmentPath.extension)"
                  v-bind:key="'fileName' + index" style="color: #098de1;">
                  Attached File.{{ row.attachmentPath.extension }}
                </a>
                <button type="button" v-bind:key="'cancelBtn' + index"
                  v-on:click="deleteAttachment(index, 'laborAttachment');" style="margin-left: 9px;">
                  <i class="fp-close" style="color: #e30000;"></i>
                </button>
              </template>
            </td>
            <td class="text-center valign-middle">
              <template v-if="rows.length != 1">
                <a href="javascript:void(0);" v-on:click="removeItem(index);"> <i class="fp-remove"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary" :disabled="disableAll">
        <i class="fp-add"></i> Add {{ labor_spelling }} Item
      </button>
      <button type="button" v-on:click="updateLineItems()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";

export default {
  name: "EvNonOemLineItemsSection",
  props: ["lineItemData", "laborTabTotal", "claimId", "hideEditSection"],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    rows: [],
    laborTypeArr: ['ADMIN', 'ADVANCED DIAGNOSTIC', 'DIAGNOSTIC', 'GENERIC', 'STANDARD', 'STANDARD DIAGNOSTIC'],
    disableAll: false,
    laborTotalTable: [],
    claimedHours: 0,
    processedHours: 0,
    laborTotalAmount: 0,
    laborProcessedAmount: 0,
    laborNetClaimedAmount: 0,
    laborNetProcessedAmount: 0,
    dealerNetProcessedAmount: 0,
    srtArr: [],
    laborRate: 0,
  }),
  created() {
    this.populateData();
  },
  methods: {
    populateData() {
      this.rows = [];
      for (const element of this.lineItemData) {
        this.rows.push(element);
      }
      this.claimedHours = this.laborTabTotal.labor_claimed_hours;
      this.processedHours = this.laborTabTotal.labor_processed_hours;
      this.laborTotalAmount = this.laborTabTotal.labor_total_amount;
      this.laborProcessedAmount = this.laborTabTotal.labor_processed_amount;
      this.laborNetClaimedAmount = this.laborTabTotal.labor_net_claimed_amount;
      this.laborNetProcessedAmount = this.laborTabTotal.labor_net_processed_amount;
      this.dealerNetProcessedAmount = this.laborTabTotal.dealer_net_processed_amount;
      this.laborRate = this.laborTabTotal.laborRate;
    },
    addRow() {
      var index = this.rows.length - 1;
      var success = this.validateSelectedRow(index);
      if (success) {
        this.rows.push({
          srt: "",
          srt_hours: 0,
          claimed_hours: 0,
          processed_hours: 0,
          labor_rate: this.laborRate,
          labor_claimed_amount: 0,
          labor_processed_amount: 0,
          srt_error_msg: "",
          claimed_hours_error_msg: "",
          item_id: "",
          attachmentPath: null,
          attachment: null,
          attachmentError: null,
          attachmentRequired: false,
        });
      }
    },
    removeItem(index) {
      this.deleteAttachment(index, 'laborAttachment');
      if (this.rows.length > 1) {
        this.rows.splice(index, 1);
      }
      this.calculateLaborTotals(index);
      this.calculateTotals();
    },
    clearRowErrorMessages(index) {
      this.rows[index].srt_error_msg = "";
      this.rows[index].claimed_hours_error_msg = "";
      this.rows[index].attachmentError = "";
    },
    validateSelectedRow(index) {
      var success = true;
      this.clearRowErrorMessages(index);
      if (this.rows[index].srt == null || this.rows[index].srt == "") {
        this.rows[index].srt_error_msg = "SRT Required";
        success = false;
      }

      if (this.rows[index].claimed_hours == null || this.rows[index].claimed_hours == 0) {
        this.rows[index].claimed_hours_error_msg = "Claim Hours Required";
        success = false;
      }

      if (this.rows[index].attachmentRequired && this.rows[index].attachmentPath == null) {
        this.rows[index].attachmentError = "Attachment is required and must be uploaded!";
        success = false;
      }
      return success;
    },
    validateAllRowsForSend() {
      var success = false;
      for (var i = 0; i < this.rows.length; i++) {
        var success = this.validateSelectedRow(i);
        if (!success) {
          break;
        }
      }
      return success;
    },
    calculateTotalLaborClaimed() {
      this.laborTotalAmount = 0;
      for (const element of this.rows) {
        var rowClaimed = parseFloat(element.claimed);
        if (typeof (rowClaimed) === 'number' && rowClaimed > 0) {
          this.laborTotalAmount = this.laborTotalAmount + rowClaimed;
        }
      }
      this.calculateTotalLaborNetAmount();
    },
    calcualteTotalLaborHours(index) {
      this.claimedHours = 0;
      for (const element of this.rows) {
        var rowHour = parseFloat(element.hours);
        if (typeof (rowHour) === 'number' && rowHour > 0) {
          this.claimedHours = this.claimedHours + rowHour;
        }
      }
      this.calculateTotalLaborNetAmount();
    },
    calculateTotalLaborNetAmount() {
      this.laborNetClaimedAmount = this.laborTotalAmount * this.claimedHours;
    },
    calculateLaborTotals(index) {
      this.calculateTotalLaborClaimed();
      this.calcualteTotalLaborHours(index);
    },
    onSearchSrt(search, loading) {
      if (search.length > 1) {

        loading(true);
        this.searchField(loading, search, 'labor_srt', '');
      }
    },
    populateSrtFields(index) {
      this.rows[index].srt_hours = this.rows[index].srt.hours;

      if (this.rows[index].claimed_hours == 0) {
        this.rows[index].claimed_hours = this.rows[index].srt_hours;
        this.calcualteTotalLaborHours(index);
      }
      this.calculateLaborClaimedAmount(index);
    },
    getLaborRate(laborRate){
      var self = this;
      self.laborRate = "$" + this.amountFormat(laborRate);
      for (const [index,row] of self.rows.entries()) {
          row.labor_rate = self.laborRate;
          this.calculateLaborClaimedAmount(index);
      }
    },
    calculateLaborClaimedAmount(index) {
      this.rows[index].labor_claimed_amount = 0;
      const laborRate = this.amountFormatToFloat(this.rows[index].labor_rate);

      if (this.rows[index].claimed_hours > 0) {
        this.rows[index].attachmentRequired = true;
        this.rows[index].attachmentError = "Attachment Required!";
      } else {
        this.rows[index].attachmentRequired = false;
        this.rows[index].attachmentError = "";
      }

      if (this.rows[index].srt_hours < this.rows[index].claimed_hours && this.rows[index].srt_hours > 0) {
        this.rows[index].labor_claimed_amount = this.rows[index].srt_hours * laborRate;
      } else {
        this.rows[index].labor_claimed_amount = this.rows[index].claimed_hours * laborRate;
      }
      this.rows[index].labor_claimed_amount = "$" + this.amountFormat(this.rows[index].labor_claimed_amount);
      this.calculateTotals();
    },
    calculateTotals() {
      this.claimedHours = 0;
      this.laborTotalAmount = 0;
      for (const row of this.rows) {
        if (row.claimed_hours != "") {
          this.claimedHours = parseInt(row.claimed_hours) + parseInt(this.claimedHours);
        }
        const rowLaborClaimAmount = this.amountFormatToFloat(row.labor_claimed_amount);
        this.laborTotalAmount = rowLaborClaimAmount + parseFloat(this.laborTotalAmount);
      }
    },
    laborAttachmentUpload(index, event) {
      this.rows[index].attachment = event.target.files[0];
      this.rows[index].attachmentError = "";
    },
    prepareDataForUpdating(){
      this.rows.forEach((row) => {
        delete row.attachment;
      });
      const lineItemData = {
        rows: this.rows,
        claimedHours: this.claimedHours,
        laborTotalAmount: this.laborTotalAmount,
        laborNetClaimedAmount: this.laborNetClaimedAmount,
        claimId: this.claimId,
      };
      return lineItemData;
    },
    updateLineItems(){
      var self = this;
      const lineItemData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/labor-line-items",
          type: "POST",
          data: {
            lineItemData: lineItemData,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              self.hideEditSection("labor_line_items");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvLaborLineItemsSection.vue